import type { ReactNode } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

export interface IssueCartListSectionProps<Item> {
  title: string;
  items: Item[];
  renderItem: (item: Item) => ReactNode;
  headerAction?: ReactNode;
}

export const IssueCartListSection = <Item,>({
  title,
  items,
  renderItem,
  headerAction,
}: IssueCartListSectionProps<Item>) => {
  const hasHeaderAction = Boolean(headerAction);

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {headerAction}
      </Stack>
      <Paper
        variant="outlined"
        sx={{ p: 2, maxHeight: '20vh', overflow: 'auto', mt: hasHeaderAction ? 1 : 0 }}
      >
        <Stack spacing={1.5}>
          {items.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
              No items added yet
            </Typography>
          ) : (
            items.map((item, index) => {
              const isLast = index === items.length - 1;
              return (
                <Box key={index}>
                  {renderItem(item)}
                  {!isLast ? (
                    <Typography
                      component="hr"
                      sx={{ my: 1, border: 0, borderTop: '1px solid', borderColor: 'divider' }}
                    />
                  ) : null}
                </Box>
              );
            })
          )}
        </Stack>
      </Paper>
    </Box>
  );
};
